import { useEffect } from 'react';
import { queryClient } from '@/shared/api';
import { getGetCurrentUserQueryKey } from '@/shared/api/generated/current-user';
import { useAuth } from '@/shared/auth';
import { usePaywallContext } from '../model/PaywallContext';
import { PaywallModal } from './PaywallModal';

export const PaywallModalHost = () => {
  const { paywallState, closePaywall } = usePaywallContext();
  const { sessionUser } = useAuth();

  const paymentMethodOnFile = sessionUser?.subscription.paymentMethodOnFile ?? false;
  const isOpen = paywallState !== null;

  useEffect(() => {
    if (paywallState && paymentMethodOnFile) {
      closePaywall();
    }
  }, [paywallState, paymentMethodOnFile, closePaywall]);

  // While the paywall is open the user has typically been sent to the Stripe billing
  // portal in a new tab. When they return and this tab regains focus, refetch
  // `currentUser` so the `paymentMethodOnFile` flag picked up by the webhook lands in
  // the cache. The effect above then auto-closes the modal.
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        queryClient.invalidateQueries({ queryKey: getGetCurrentUserQueryKey() });
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isOpen]);

  return <PaywallModal open={isOpen} paywallState={paywallState} onClose={closePaywall} />;
};
